import styled from "styled-components";

export const CardContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 8px;
  padding: 12px;
  background: ${({ theme }) => theme.neutral.white};
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  cursor: ${({ clickable }) => clickable ? "pointer" : "default"};
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.primary.blue};
    outline-offset: 2px;
  }
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 18px rgba(46, 46, 46, 0.08);
  }
  .card-link {
    font-weight: 400;
    font-size: 12px;
    text-align: center;
    text-decoration: underline;
    color: ${({ theme }) => theme.primary.purpleLight};
    cursor: pointer;
    display: none;
  }
  .card-title {
    font-size: 14px;
    font-weight: 600;
    margin: 8px 0 4px;
    text-align: center;
    line-height: 1.2;
    color: ${({ theme }) => theme.neutral.iconGray};
  }
  .card-desc {
    font-size: 12px;
    color: ${({ theme }) => theme.text.muted};
    line-height: 1.4;
    margin: 0;
    text-align: center;
  }
  svg {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
